"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckDto = instanceOfBackgroundCheckDto;
exports.BackgroundCheckDtoFromJSON = BackgroundCheckDtoFromJSON;
exports.BackgroundCheckDtoFromJSONTyped = BackgroundCheckDtoFromJSONTyped;
exports.BackgroundCheckDtoToJSON = BackgroundCheckDtoToJSON;
exports.BackgroundCheckDtoToJSONTyped = BackgroundCheckDtoToJSONTyped;
const BackgroundCheckPackageScreeningDto_1 = require("./BackgroundCheckPackageScreeningDto");
const BackgroundCheckStatus_1 = require("./BackgroundCheckStatus");
const BackgroundCheckProvider_1 = require("./BackgroundCheckProvider");
/**
 * Check if a given object implements the BackgroundCheckDto interface.
 */
function instanceOfBackgroundCheckDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('packageName' in value) || value['packageName'] === undefined)
        return false;
    if (!('isDefaultPackage' in value) || value['isDefaultPackage'] === undefined)
        return false;
    if (!('authorizedAt' in value) || value['authorizedAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('screenings' in value) || value['screenings'] === undefined)
        return false;
    return true;
}
function BackgroundCheckDtoFromJSON(json) {
    return BackgroundCheckDtoFromJSONTyped(json, false);
}
function BackgroundCheckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'provider': (0, BackgroundCheckProvider_1.BackgroundCheckProviderFromJSON)(json['provider']),
        'externalCandidateId': json['externalCandidateId'] == null ? undefined : json['externalCandidateId'],
        'externalCaseId': json['externalCaseId'] == null ? undefined : json['externalCaseId'],
        'status': (0, BackgroundCheckStatus_1.BackgroundCheckStatusFromJSON)(json['status']),
        'packageName': json['packageName'],
        'isDefaultPackage': json['isDefaultPackage'],
        'authorizedAt': (json['authorizedAt'] == null ? null : new Date(json['authorizedAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'manuallyClearedByProfileId': json['manuallyClearedByProfileId'] == null ? undefined : json['manuallyClearedByProfileId'],
        'manualClearanceProvider': json['manualClearanceProvider'] == null ? undefined : json['manualClearanceProvider'],
        'screenings': (json['screenings'].map(BackgroundCheckPackageScreeningDto_1.BackgroundCheckPackageScreeningDtoFromJSON)),
    };
}
function BackgroundCheckDtoToJSON(json) {
    return BackgroundCheckDtoToJSONTyped(json, false);
}
function BackgroundCheckDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'provider': (0, BackgroundCheckProvider_1.BackgroundCheckProviderToJSON)(value['provider']),
        'externalCandidateId': value['externalCandidateId'],
        'externalCaseId': value['externalCaseId'],
        'status': (0, BackgroundCheckStatus_1.BackgroundCheckStatusToJSON)(value['status']),
        'packageName': value['packageName'],
        'isDefaultPackage': value['isDefaultPackage'],
        'authorizedAt': (value['authorizedAt'] == null ? null : value['authorizedAt'].toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'manuallyClearedByProfileId': value['manuallyClearedByProfileId'],
        'manualClearanceProvider': value['manualClearanceProvider'],
        'screenings': (value['screenings'].map(BackgroundCheckPackageScreeningDto_1.BackgroundCheckPackageScreeningDtoToJSON)),
    };
}
//# sourceMappingURL=BackgroundCheckDto.js.map